import UploadAndResizeFile from './UploadAndResizeFile';

export default UploadAndResizeFile;
